import { Login } from './auth/login'
import { Refresh } from './auth/refresh'

import { GetFarming } from './farming/get-farming'
import { StartFarming } from './farming/start-farming'
import { StopFarming } from './farming/stop-farming'
import { ClaimTask } from './tasks/claim'
import { TakeTask } from './tasks/take'
import { ListTasks } from './tasks/list'
import { Visit } from './visit'
import { GetUser } from './user'
import { ClaimReferral } from './claim-referral'
import { GameStart } from './game/start'
import { GameClaim } from './game/claim'
import { GameEnd } from './game/end'
import { SyncTaps } from './sync-taps'

export const api = {
  auth: {
    login: new Login().perform,
    refresh: new Refresh().perform
  },
  farming: {
    get: new GetFarming().perform,
    start: new StartFarming().perform,
    stop: new StopFarming().perform
  },
  tasks: {
    list: new ListTasks().perform,
    claim: new ClaimTask().perform,
    take: new TakeTask().perform
  },
  game: {
    start: new GameStart().perform,
    claim: new GameClaim().perform,
    end: new GameEnd().perform
  },
  visit: new Visit().perform,
  user: new GetUser().perform,
  claimReferral: new ClaimReferral().perform,
  syncTaps: new SyncTaps().perform
}
